import React from "react";

import { Icon, Spin } from "components";

export const ModuleIconStatus = ({ status = null, disabled = false, loading = false, icon, style }) => (
  <span style={style} className={`module-icon-status ${status} ${disabled ? "disabled" : ""} ${loading ? "loading" : ""}`}>
    {loading ? <Spin iconName="tabler/loader" /> : <Icon iconName={icon} className="icon inline" />}
  </span>
);
